<ch-breadcrumb [parts]="breadcrumb" (goTo)="(null)"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    Tags
    <a id='tagsListingNew' [routerLink]="['/admin/offer-tags/add']" class="btn btn-default pull-right">
      New
    </a>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">
        No items found.
      </p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span class="col-name">Name</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td class="tag-name">
              <span>{{ item }}</span>
            </td>
            <td class="col-md-1">
              <a class="btn btn-danger" (click)="deleteTag(item)"> Delete </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination *ngIf="!loading" [totalItems]="totalItems" [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize" (pageChanged)="onPageChanged($event)"></ch-pagination>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/tags/tags-listing/tags-listing.component.html